<figure
	class="report-image"
	[class.report-image--beside]="beside"
	[class.report-image--right]="image.align === 'right'"
	[class.report-image--overlay]="!beside && caption === 'overlay'"
>
	<div
		#frame
		class="report-image__frame"
		[class.report-image__frame--cropping]="cropping"
		[style.flex-basis.%]="beside ? frameWidth * 100 : null"
		[attr.tabindex]="cropping ? 0 : null"
		[attr.role]="cropping ? 'application' : null"
		[attr.aria-label]="
			cropping
				? 'Drag the picture, or use the arrow keys, to choose what shows'
				: null
		"
		(pointerdown)="onPointerDown($event)"
		(pointermove)="onPointerMove($event)"
		(pointerup)="onPointerUp($event)"
		(pointercancel)="onPointerUp($event)"
		(keydown)="onKeydown($event)"
	>
		<img
			#picture
			class="report-image__picture"
			draggable="false"
			[src]="src"
			[alt]="image.title"
			[style.object-position]="objectPosition"
			[style.transform-origin]="objectPosition"
			[style.transform]="transform"
		/>
		<!-- Text, never an icon font: the PDF's headless browser draws it
		     with whatever fonts it has. -->
		<span class="report-image__ai" *ngIf="aiLabel">AI image</span>
	</div>
	<figcaption
		class="report-image__caption"
		*ngIf="beside || caption !== 'none'"
	>
		{{ image.title }}
	</figcaption>
</figure>
